import React from 'react';
import './customAlert.css';

const CustomAlert = ({ visible, message, onConfirm, onCancel, onClose, title = 'Alert', icon = '⚠️' }) => {
  if (!visible) return null;
  
  const isConfirmation = typeof onConfirm === 'function' && typeof onCancel === 'function';
  
  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert-box">
        <div className="custom-alert-header">
          <div className="custom-alert-header-content">
            <div className="custom-alert-icon-container">
              <span className="custom-alert-icon">{icon}</span>
            </div>
            <h3 className="custom-alert-title">{title}</h3>
          </div>
        </div>

        <div className="custom-alert-content">
          <p className="custom-alert-message">{message}</p>
        </div>

        <div className="custom-alert-buttons">
          {isConfirmation ? (
            <>
              <button className="custom-alert-button cancel" onClick={onCancel}>
                <span>❌</span>
                <span>Cancel</span>
              </button>
              <button className="custom-alert-button confirm" onClick={onConfirm}>
                <span>✅</span>
                <span>Confirm</span>
              </button>
            </>
          ) : (
            <button className="custom-alert-button close" onClick={onClose}>
              <span>✓</span>
              <span>Close</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomAlert;